import React, { useState, useEffect } from "react";
import { CMSNavbarComponent } from "../Components/navbar/CMSnavcomponent";
import {
  BannerView,
  CategorieView,
  CategoryGroupingView,
  FullWidthBannerView,
  MiddleBannerView,
  OneByTwoView,
  ProductSectionView,
  VerticalBannerView,
  FeaturedThisWeekView,
} from "../Components/Shopidy";
import axiosConfig from "../Service/axiosConfig";
import "../Components/Shopidy/FullwidthbannerView.css";
const HomepageView = () => {
  const [Login, Setlogin] = useState(false);
  const [components, setComponents] = useState([]);
  const GetData = async () => {
    try {
      const response = await axiosConfig.get("/cms/get_homepagedesign/");
      let data = response.data.results;
      console.log(data, "datiaaaaa")
      const combinedData = [
        ...data
          .filter((item) => item.title === "Banner Slider")
          .map((item) => ({
            type: "Banners",
            content: item.slider,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "Full Width Banner" && !item.title.toLowerCase().includes("featured"))
          .map((item) => ({
            type: "MainBanners",
            content: item.banner,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title.toLowerCase().includes("featured"))
          .map((item) => ({
            type: "Featured This Week",
            content: item.banner,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "Promotional" || (item.promotional_category && item.promotional_category.length > 0))
          .map((item) => ({
            type: "promotional_category",
            content: item.promotional_category,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "Categorie" && item.category)
          .map((item) => ({
            type: "Categories",
            content: item.category,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "Products")
          .map((item) => ({
            type: "Products",
            content: item.subcategory,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "One By Two Banners")
          .map((item) => ({
            type: "One By Two Banners",
            content: item.onebytwo_banners,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "Middle Banners")
          .map((item) => ({
            type: "Middle Banners",
            content: item.middle_banners,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "Vertical Banners")
          .map((item) => ({
            type: "Vertical Banners",
            content: item.vertical_banners,
            subcategory: item.vertical_banners.map((item) => item.subcategory),
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "Category Grouping" && item.category_grouping)
          .map((item) => ({
            type: "Category Grouping",
            content: item.category_grouping,
            sort: item.sort,
          })),
      ];

      combinedData.sort((a, b) => a.sort - b.sort);
      console.log(combinedData, "combineDatiaaa")
      setComponents(combinedData);
    } catch (error) {
      console.error("Error fetching homepage design:", error);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  return (
    <>
      <div className="child-sidenav">
        <CMSNavbarComponent />
        <div className="childnav-content banner-slider-view">
          {components?.map((item, index) => {
            if (item.type === "MainBanners") {
              return <FullWidthBannerView key={index} data={item.content} />;
            }
            if (item.type === "Featured This Week") {
              return <FeaturedThisWeekView key={index} data={item.content} />;
            }

            if (item.type === "Banners") {
              return <BannerView key={index} data={item.content} />;
            }
            if (item.type === "Categories") {
              return (
                <div className="categories-section">
                  <CategorieView key={index} data={item.content} />
                </div>
              );
            }
            if (item.type === "Category Grouping") {
              return (
                <div className="categories-section" key={index}>
                  <CategoryGroupingView key={index} data={item.content} />
                </div>
              );
            }
            if (item.type === "Products") {
              return (
                <div className="display-categories-section">
                  <ProductSectionView
                    Setlogin={Setlogin}
                    LoginAccount={Login}
                    key={index}
                    data={item.content}
                  />
                </div>
              );
            }
           
            if (item.type === "One By Two Banners") {
              return <OneByTwoView key={index} data={item.content} />;
            }
            if (item.type === "Middle Banners") {
              return <MiddleBannerView key={index} data={item.content} />;
            }
            if (item.type === "Vertical Banners") {
              return (
                <VerticalBannerView
                  key={index}
                  data={item.content}
                  subcategory={item.subcategory}
                />
              );
            }

            return null;
          })}
        </div>
      </div>
    </>
  );
};

export { HomepageView };
